import NoveltyFlavorDecompositionTable from './NoveltyFlavorDecompositionTable';
export default NoveltyFlavorDecompositionTable;
